
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 56 56"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#1DD8AA"}},[_c('circle',{attrs:{"cx":"28","cy":"28","r":"28"}}),_c('path',{attrs:{"fill":"#fff","d":"M22.815 37.691a1.208 1.208 0 01-.06-.055l-9.389-9.457a1.25 1.25 0 111.768-1.768l8.529 8.58 17.209-16.64a1.25 1.25 0 011.736 1.798l-18.1 17.502a1.25 1.25 0 01-1.693.04z"}})])])
          )
        }
      }
    